export default "__VITE_ASSET__LrlKw4WH__"